import React from 'react';

export const OptionButton = ({
  label,
  isSelected,
  handleSelect,
}: {
  label: string;
  isSelected: boolean;
  handleSelect: () => void;
}) => {
  return (
    <button
      onClick={handleSelect}
      className='flex items-center border-none bg-transparent'
    >
      <img
        src={
          isSelected
            ? '/icons/radio-button-active.svg'
            : '/icons/radio-button.svg'
        }
        width={20}
        height={20}
        className='mr-5'
        alt=' '
      />
      <span className='text-14px leading-7 text-customBlack'>{label}</span>
    </button>
  );
};
